<h1 mat-dialog-title>Edit User Email</h1>
<div mat-dialog-content>
  <div class="current-email">
    <span
      >Current email: <strong>{{ currentEmail }}</strong></span
      >
      <mat-chip-listbox>
        <mat-chip [color]="emailVerified ? 'primary' : 'warn'" selected>
          {{ emailVerified ? 'Verified' : 'Not Verified' }}
        </mat-chip>
      </mat-chip-listbox>
    </div>

    <form class="form" [formGroup]="form">
      <mat-form-field class="fullwidth">
        <mat-label>New Email Address</mat-label>
        <input matInput formControlName="newEmail" placeholder="new@example.com" />
        @if (form.get('newEmail')?.hasError('required')) {
          <mat-error>Email is required</mat-error>
        }
        @if (form.get('newEmail')?.hasError('email')) {
          <mat-error
            >Enter a valid email address</mat-error
            >
          }
        </mat-form-field>
      </form>

      <div class="verify-actions-container">
        @if (!emailVerified) {
          <div class="verify-actions">
            <button mat-raised-button color="accent" (click)="verifyEmail()">Verify User</button>
            <button mat-raised-button color="accent" (click)="forceVerifyEmail()">Force Verify</button>
          </div>
        }
        @if (emailVerified) {
          <div class="verify-actions">
            <mat-icon color="primary">check_circle</mat-icon>
            <span>Email is verified</span>
          </div>
        }
      </div>
    </div>
    <div class="buttons" mat-dialog-actions>
      <button
        mat-raised-button
        color="primary"
        class="primarybutton"
        [disabled]="saving || form.invalid"
        (click)="saveEmail()"
        >
        {{ saving ? 'Saving...' : 'Change Email' }}
      </button>
      <button mat-raised-button (click)="onDismiss()">Cancel</button>
    </div>
